/**
 * Theme registry. Each theme defines CSS HSL variables.
 * Saffron is required (Indian flag colors).
 */
export const THEMES = {
  default: {
    label: "Default · Navy",
    description: "Classic navy & teal banking palette",
    icon: "🏛️",
    light: {
      primary: "221 55% 22%",
      "primary-foreground": "210 40% 98%",
      accent: "186 55% 28%",
      "accent-foreground": "210 40% 98%",
      ring: "186 55% 28%",
      "chart-1": "221 55% 30%",
      "chart-2": "186 55% 38%",
    },
    dark: {
      primary: "210 40% 96%",
      "primary-foreground": "221 55% 18%",
      accent: "186 55% 40%",
      "accent-foreground": "222 35% 8%",
      ring: "186 55% 40%",
    },
  },
  saffron: {
    label: "Saffron · हिन्दुस्तान",
    description: "Saffron primary with Indian green accent (national colours)",
    icon: "🇮🇳",
    light: {
      primary: "28 95% 45%",
      "primary-foreground": "45 40% 98%",
      accent: "120 60% 28%",
      "accent-foreground": "45 40% 98%",
      ring: "28 95% 50%",
      "chart-1": "28 95% 50%",
      "chart-2": "120 60% 32%",
      "chart-3": "45 95% 55%",
      background: "45 35% 98%",
    },
    dark: {
      primary: "32 95% 60%",
      "primary-foreground": "30 40% 12%",
      accent: "120 50% 45%",
      "accent-foreground": "30 40% 12%",
      ring: "32 95% 60%",
      "chart-1": "32 95% 60%",
      "chart-2": "120 50% 45%",
    },
  },
  forest: {
    label: "Forest Green",
    description: "Calm green for growth & nature",
    icon: "🌿",
    light: {
      primary: "148 50% 22%",
      "primary-foreground": "140 40% 98%",
      accent: "160 60% 30%",
      "accent-foreground": "140 40% 98%",
      ring: "160 60% 32%",
    },
    dark: {
      primary: "140 40% 90%",
      "primary-foreground": "148 50% 18%",
      accent: "160 60% 50%",
      "accent-foreground": "148 50% 12%",
      ring: "160 60% 50%",
    },
  },
  royal: {
    label: "Royal Blue",
    description: "Deep blue traditional banking",
    icon: "👑",
    light: {
      primary: "222 75% 30%",
      "primary-foreground": "220 40% 98%",
      accent: "205 85% 38%",
      "accent-foreground": "220 40% 98%",
      ring: "205 85% 42%",
    },
    dark: {
      primary: "220 40% 96%",
      "primary-foreground": "222 75% 22%",
      accent: "205 85% 55%",
      "accent-foreground": "222 75% 12%",
      ring: "205 85% 55%",
    },
  },
  indigo: {
    label: "Indigo Fintech",
    description: "Modern fintech indigo",
    icon: "⚡",
    light: {
      primary: "243 70% 38%",
      "primary-foreground": "245 40% 98%",
      accent: "275 75% 50%",
      "accent-foreground": "245 40% 98%",
      ring: "275 75% 55%",
    },
    dark: {
      primary: "245 40% 96%",
      "primary-foreground": "243 70% 30%",
      accent: "275 75% 68%",
      "accent-foreground": "245 40% 12%",
      ring: "275 75% 68%",
    },
  },
  slate: {
    label: "Slate Minimal",
    description: "Neutral graphite for minimal UI",
    icon: "️◼",
    light: {
      primary: "215 25% 22%",
      "primary-foreground": "215 30% 98%",
      accent: "215 30% 40%",
      "accent-foreground": "215 30% 98%",
      ring: "215 30% 40%",
    },
    dark: {
      primary: "215 30% 96%",
      "primary-foreground": "215 25% 18%",
      accent: "215 30% 60%",
      "accent-foreground": "215 25% 12%",
      ring: "215 30% 60%",
    },
  },
};

export function applyTheme(name, mode = "light") {
  const t = THEMES[name] || THEMES.default;
  const tokens = t[mode] || {};
  const root = document.documentElement;
  Object.entries(tokens).forEach(([k, v]) => {
    root.style.setProperty(`--${k}`, v);
  });
  // toggle dark class
  if (mode === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
}

export function clearTheme() {
  const root = document.documentElement;
  Object.keys(THEMES.default.light).forEach((k) => root.style.removeProperty(`--${k}`));
  Object.keys(THEMES.default.dark).forEach((k) => root.style.removeProperty(`--${k}`));
}
